var _rect, _g, _circle, _circle2, _g2, _g3, _g4, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgSearchEmpty = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 150,
    height: 150,
    viewBox: "0 0 150 150",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1928_275577",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 150,
    height: 150
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 150,
    height: 150,
    fill: "#D9D9D9"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1928_275577)"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_ii_1928_275577)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 22.197C12 24.9005 12.9407 27.4958 14.6133 29.4074L53.6367 74.0057C55.3093 75.9172 56.25 78.5126 56.25 81.2161V119.803C56.25 125.436 60.2436 130 65.1724 130H76.8276C81.7564 130 85.75 125.436 85.75 119.803V81.2161C85.75 78.5126 86.6907 75.9172 88.3633 74.0057L127.387 29.4074C129.059 27.4958 130 24.9005 130 22.197C130 16.5642 126.006 12 121.078 12H20.9224C15.9936 12 12 16.5642 12 22.197Z",
    fill: "url(#paint0_linear_1928_275577)"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 106.464,
    cy: 92.4999,
    r: 37.4999,
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_1928_275577",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 68,
    y: 55,
    width: 76,
    height: 75
  }, _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 106.464,
    cy: 92.4999,
    r: 37.4999,
    fill: "url(#paint1_linear_1928_275577)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_1928_275577)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_1928_275577)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 22.197C12 24.9005 12.9407 27.4958 14.6133 29.4074L53.6367 74.0057C55.3093 75.9172 56.25 78.5126 56.25 81.2161V119.803C56.25 125.436 60.2436 130 65.1724 130H76.8276C81.7564 130 85.75 125.436 85.75 119.803V81.2161C85.75 78.5126 86.6907 75.9172 88.3633 74.0057L127.387 29.4074C129.059 27.4958 130 24.9005 130 22.197C130 16.5642 126.006 12 121.078 12H20.9224C15.9936 12 12 16.5642 12 22.197Z",
    fill: "url(#paint2_linear_1928_275577)"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_iii_1928_275577)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 106.464,
    cy: 92.4999,
    r: 37.4999,
    fill: "#8DC8E8",
    fillOpacity: 0.5
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_diiii_1928_275577)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M122.925 100.214L115.175 92.3711L122.946 84.5066C125.28 82.1447 125.286 78.32 122.96 75.9655C120.633 73.6111 116.854 73.6171 114.52 75.979L106.749 83.8435L99 76.0009C96.6736 73.6464 92.8944 73.6524 90.5606 76.0143C88.2269 78.3762 88.2209 82.2009 90.5473 84.5554L98.2966 92.398L90.5257 100.263C88.1919 102.624 88.186 106.449 90.5124 108.804C92.8389 111.158 96.618 111.152 98.9518 108.79L106.723 100.926L114.472 108.768C116.798 111.123 120.578 111.117 122.911 108.755C125.245 106.393 125.251 102.568 122.925 100.214Z",
    fill: "url(#paint3_linear_1928_275577)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_ii_1928_275577",
    x: 12,
    y: 10.4944,
    width: 118.376,
    height: 120.258,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -1.50557
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.88197
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "multiply",
    in2: "shape",
    result: "effect1_innerShadow_1928_275577"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.376393,
    dy: 0.752787
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.88197
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "overlay",
    in2: "effect1_innerShadow_1928_275577",
    result: "effect2_innerShadow_1928_275577"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_1928_275577",
    x: 4.96655,
    y: 4.96655,
    width: 132.067,
    height: 132.067,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.51672,
    result: "effect1_foregroundBlur_1928_275577"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_iii_1928_275577",
    x: 67.3866,
    y: 53.4228,
    width: 76.5772,
    height: 77.581,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.004
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.00801
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "color-dodge",
    in2: "shape",
    result: "effect1_innerShadow_1928_275577"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 9.56075
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "screen",
    in2: "effect1_innerShadow_1928_275577",
    result: "effect2_innerShadow_1928_275577"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -1.57723,
    dy: -1.57723
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.94307
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.29555 0 0 0 0 0.575 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "multiply",
    in2: "effect2_innerShadow_1928_275577",
    result: "effect3_innerShadow_1928_275577"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_diiii_1928_275577",
    x: 85.0093,
    y: 72.6988,
    width: 43.453,
    height: 45.3912,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3.76214
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.88107
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1928_275577"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1928_275577",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -0.376214,
    dy: -0.752427
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.752427
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_1928_275577"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.376214,
    dy: 0.752427
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.752427
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_innerShadow_1928_275577",
    result: "effect3_innerShadow_1928_275577"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.376214,
    dy: 0.752427
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.88107
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect3_innerShadow_1928_275577",
    result: "effect4_innerShadow_1928_275577"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -1.50485
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.88107
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect4_innerShadow_1928_275577",
    result: "effect5_innerShadow_1928_275577"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1928_275577",
    x1: 45.3065,
    y1: -2.89899,
    x2: 162.632,
    y2: 102.645,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8DC8E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.445972,
    stopColor: "#0078D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.895626,
    stopColor: "#2A446F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1928_275577",
    x1: 91.1336,
    y1: 46.5095,
    x2: 116.605,
    y2: 116.556,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#51E6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0001,
    stopColor: "#51E6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.838991,
    stopColor: "#0078D4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1928_275577",
    x1: 45.3065,
    y1: -2.89899,
    x2: 162.632,
    y2: 102.645,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8DC8E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.445972,
    stopColor: "#0078D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.895626,
    stopColor: "#2A446F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1928_275577",
    x1: 96.1725,
    y1: 52.7409,
    x2: 150.502,
    y2: 84.1427,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E7F0F7"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgSearchEmpty);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Search_Empty.614fab1602a55085cdfc00aca029d694.svg";